/* eslint-disable prettier/prettier */
import * as newsAPI from "@/API/news.js";

const getDefaultState = () => {
  return {
    messages: [],
    userMessages: [],
    readMessages: [],
    deletedMessages: [],
    autoOpenNews: true,
  };
};
const state = getDefaultState();

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setMessages(state, payload) {
    state.messages = payload;
  },
  setUserMessages(state, payload) {
    state.userMessages = payload;
  },
  setAutoOpenNewsCenter: (state, boolean) => (state.autoOpenNews = boolean),

  markAsRead: (state, id) => {
    if (!state.readMessages.includes(id)) {
      state.readMessages.push(id);
    }
  },

  markAsDeleted: (state, id) => {
    if (state.deletedMessages.includes(id)) return;
    state.deletedMessages.push(id);
  },
  updateUserMessage: (state, message) => {
    const idx = state.userMessages.findIndex((msg) => msg.id === message.id);
    if (idx !== -1) state.userMessages[idx] = message;
  },
  removeUserMessage(state, id) {
    state.userMessages = state.userMessages.filter((msg) => msg.id !== id);
  },
  removeMessage(state, id) {
    state.messages = state.messages.filter((msg) => msg.id !== id);
  },
  resetReadMessages(state) {
    state.readMessages = [];
  },
  resetDeletedMessages(state) {
    state.deletedMessages = [];
  },
};

const getters = {
  unreadMessages: (state) => {
    let unreadMessages = state.messages.filter(
      (message) =>
        !state.readMessages.includes(message.id) &&
        !state.deletedMessages.includes(message.id)
    );
    let unreadUserMessages = state.userMessages.filter(
      (message) =>
        !message.seen_at &&
        !state.readMessages.includes(message.id) &&
        !state.deletedMessages.includes(message.id)
    );
    return unreadMessages.concat(unreadUserMessages);
  },
  unreadMessagesAvailable: (state, getters) =>
    getters.unreadMessages && getters.unreadMessages.length > 0,
  newsCategories: (state) => {
    let userFilters = [];
    let result = [];
    state.userMessages.forEach((message) => {
      if (message.news_type) {
        userFilters.push(message.news_type.title);
      }
    });
    let userFiltersMinusDuplicates = new Set(userFilters);

    userFiltersMinusDuplicates.forEach((item) =>
      result.push({ title: item, userNews: true })
    );

    return result;
  },
};
const actions = {
  fetchNews({ commit }) {
    return Promise.all([newsAPI.fetchNews(), newsAPI.fetchUserNews()])
      .then(([annRes, userRes]) => {
        const announcements = annRes?.data?.data?.news || [];
        const userNews = userRes?.data?.data?.news || [];

        commit(
          "setMessages",
          Array.isArray(announcements) ? announcements : []
        );
        commit("setUserMessages", Array.isArray(userNews) ? userNews : []);
      })
      .catch((e) => {
        console.error("[news/fetchNews] failed:", e);
        commit("setMessages", []);
        commit("setUserMessages", []);
        throw e;
      });
  },
  markUserNewsAsRead({ state, commit }) {
    state.userMessages.forEach((news) => {
      if (!news.seen_at) {
        newsAPI
          .markUserNewsAsRead(news.id)
          .then((res) => commit("updateUserMessage", res.data.data.news))
          .catch((e) => console.log(e));
      }
    });
  },
  markNewsAsDeleted({ state, commit }, id) {
    commit("markAsDeleted", id);

    const isUserNews = state.userMessages.some((msg) => msg.id === id);
    if (isUserNews) {
      commit("removeUserMessage", id);
      newsAPI.deleteUserNews(id).catch((e) => console.log(e));
    } else {
      commit("removeMessage", id);
    }
  },
  deleteAllUserNews({ commit }) {
    return newsAPI
      .deleteAllUserNews()
      .then(() => {
        commit("setUserMessages", []);
      })
      .catch((e) => console.error("Failed to delete all news:", e));
  },
  markAllUserAnnouncementsAsRead({ state, commit }) {
    return newsAPI
      .markAllUserAnnouncementsAsRead()
      .then(() => {
        // Update all userMessages as read locally
        state.userMessages = state.userMessages.map((news) => ({
          ...news,
          seen_at: new Date().toISOString(),
        }));
      })
      .catch((e) =>
        console.error("Failed to mark all announcements as read:", e)
      );
  },
  resetNewsState({ commit }) {
    commit("resetState");
  },
  markAllAnnouncementsAsRead({ state, commit }) {
    state.messages.forEach((msg) => {
      commit("markAsRead", msg.id);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
